import { PopupContentProps } from "./phoenix-shade.types"

const PopupContent: React.FC<PopupContentProps> = ({ properties, timeColumn }) => {
  const totValue = properties[timeColumn]
  const vegValue = properties[timeColumn.replace("_tot", "_veg")]
  const bldValue = properties[timeColumn.replace("_tot", "_bld")]

  return (
    <div className="font-md rounded bg-[#171717]/90 p-3 text-center text-white">
      <div className="text-base">
        <div className="font-bold uppercase text-[#9CACC1]">{properties.PROPERTY_N}</div>
        <div className="font-bold text-white">
          Total Shade: {typeof totValue === "number" ? `${Math.round(totValue)}%` : "N/A"}
        </div>
      </div>
      <hr className="border-1 my-1 border-white" />
      Building Shade: {typeof bldValue === "number" ? `${Math.round(bldValue)}%` : "0%"}
      <br />
      Tree and Other Shade: {typeof vegValue === "number" ? `${Math.round(vegValue)}%` : "0%"}
    </div>
  )
}

export default PopupContent
